<template>
  <van-popup v-model="open" position="bottom" round closeable>
      <div class="popup">
        <div class="popup-title">收费明细</div>
        <div class="price">
          <span style="font-size:14px;">预计</span>
          <span style="font-size:12px;color:#F1892E;">￥</span>
          <span style="font-size:20px;color:#F1892E;">{{zeroPadding(amountIn)}}</span>
        </div>
        <div class="tips">
          <span>若产生等候费/高速费/停车费/搬运费，需另行支付；请根据</span>
          <span style="color:#FFBD2D;">《二次费用收费标准》</span>
          <span>与司机协商</span>
        </div>
        <!-- <div class="detailsBox" v-if="orderInfo.firstPaymentPaid == 0">
          <div class="detailsItem">
            <div class="details-title flex">
              <div style="margin-right:auto;">运输费用</div>
              <div>￥{{zeroPadding(orderInfo.mileageFeeIn)}}</div>
            </div>
            <div class="details-content">总里程{{orderInfo.mileage}}公里</div>
          </div>
          <div class="details-line"></div>
          <div class="detailsItem">
            <div class="details-title flex">
              <div style="margin-right:auto;">发票税费</div>
              <div v-if="(orderInfo.firstPaymentPaid == '0' && orderInfo.firstInvoiceFeeIn == 0) || (orderInfo.firstPaymentPaid == '1' && orderInfo.invoiceFee == 0)" style="color:#EC892E;">免费</div>
              <div v-else>￥{{orderInfo.firstPaymentPaid == '0'?zeroPadding(orderInfo.firstInvoiceFeeIn):zeroPadding(orderInfo.invoiceFee)}}</div>
            </div>
            <div class="details-content">电子普票免费，纸质专票6%或9%</div>
          </div>
        </div> -->
        <div class="detailsBox">
          <div v-for="(item,index) in costList" :key="index">
            <div class="detailsItem" v-if="item.keyName === 'mileageFeeIn'">
              <div class="details-title flex">
                <div style="margin-right:auto;">运输费用</div>
                <div>￥{{zeroPadding(orderInfo.mileageFeeIn)}}</div>
              </div>
              <div class="details-content">总里程{{math(orderInfo.mileage,1000).divide()}}公里</div>
            </div>
            <div class="detailsItem" v-else-if="['firstInvoiceFeeIn','invoiceFee'].includes(item.keyName) && type === 'first'">
              <div class="details-title flex">
                <div style="margin-right:auto;">发票税费</div>
                <!-- 首款为0 -->
                <div v-if="item.value <= 0" style="color:#EC892E;">免费</div>
                <div v-else>￥{{ item.value }}</div>
              </div>
              <div class="details-content">电子普票免费，纸质专票6%或9%</div>
            </div>
            <div class="detailsItem" v-else-if="['invoiceFee'].includes(item.keyName) && type === 'last'">
              <div class="details-title flex">
                <div style="margin-right:auto;">{{ item.label }}</div>
                <div>￥{{ item.value }}</div>
              </div>
            </div>
            <div class="detailsItem" v-else>
              <div class="details-title flex">
                <div style="margin-right:auto;">{{ item.label }}</div>
                <div>￥{{ item.value }}</div>
              </div>
            </div>
            <div class="details-line"></div>
          </div>
        </div>
      </div>
    </van-popup>
</template>

<script>
import { Popup } from "vant";
export default {
  name:"chargeDetailsPopup",
  components:{
    [Popup.name]: Popup
  },
  data(){
    return {
      open:false,
      orderInfo:{},
      costList:[],
      amountIn:"",
      type:''
    }
  },
  inject:["zeroPadding","math"],
  methods:{
    show(options){
      this.orderInfo = options.orderInfo;
      this.costList = options.costList;
      this.amountIn = options.amountIn;
      this.type = options.type;
      this.open = true;
    }
  }
}
</script>

<style scoped lang="scss">
  .popup {
  padding: 16px;
  .price {
    margin-top: 12px;
  }
  .popup-title {
    font-size: 16px;
  }
  .tips {
    font-size: 12px;
    margin-top: 12px;
  }
  .detailsBox {
    background-color: #F8F8F8;
    border-radius: 4px;
    padding: 24px 16px;
    margin-top: 10px;
    max-height: 300px;
    overflow-y: auto;
  }
  .details-title {
    align-items: center;
    color: #393939;
    font-size: 16px;
    line-height: 24px;
  }
  .details-content {
    font-size: 12px;
    line-height: 20px;
    color: #C9C2BB;
  }
  .details-line {
    border-bottom: 1px solid #EBE5E0;
    margin: 16px 0;
  }
}
.flex {
  display: flex;
  align-items: center;
}
</style>